import { CreateEmailTemplateRequest, emailtemplatesApi } from "api";
import { routes } from "consts";
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useToaster } from "utils";

import { EmailTemplateForm } from "./EmailTemplateForm/EmailTemplateForm";
import { PaziaBreadcrumbs } from "components/atoms";
import { EmailPageHeader } from "../components/EmailPageHeader";

export const AddEmailTriggerPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();
  const [searchParams] = useSearchParams();
  const typeParam = searchParams.get("type");
  const isGeneric = searchParams.get("generic") === "true";
  const initialType = typeParam ? Number(typeParam) : isGeneric ? 0 : undefined;

  const onSubmit = async (request: CreateEmailTemplateRequest) => {
    try {
      await emailtemplatesApi.create(request);
      navigate(routes.EMAILS + (isGeneric ? routes.EMAILS_TEMPLATES : routes.EMAILS_TRIGGERS));
      showSuccess("Utworzono szablon e-mail.");
    } catch (e) {
      showError("Wystąpił błąd podczas tworzenia szablonu e-mail.");
      console.error(e);
    }
  };

  return (
    <div>
      <PaziaBreadcrumbs
        className="mb-2"
        segments={[
          {
            title: isGeneric ? "Szablony" : "Wyzwalacze",
            path: routes.EMAILS + (isGeneric ? routes.EMAILS_TEMPLATES : routes.EMAILS_TRIGGERS),
          },
          { title: "Tworzenie szablonu e-mail" },
        ]}
      />
      <EmailPageHeader>Nowy szablon e-mail</EmailPageHeader>

      <EmailTemplateForm onSubmit={onSubmit} initialType={initialType} isGeneric={isGeneric} />
    </div>
  );
};
